var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-06-28
 * @brief SEI 운영관리 - 기기등록 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState, urlState } from "../../../../recoil/menuState";
import { infoPop, reLoad, userInfoLoginState } from "../../../../recoil/userState";
// utils
import { alertState, curAdminTreeState, curConsultInfo, noneUrl } from "../../../../recoil/assessmentState";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import EhpPagination from "../../../common/pagination/EhpPagination";
// datepicker
import dayjs from "dayjs";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { useNavigate } from "react-router-dom";
// component
//압축 다운로드
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
function EquipmentRegist(props) {
    // trans, navgate, ref
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const setConsultInfo = useSetRecoilState(curConsultInfo);
    const setPopInfo = useSetRecoilState(infoPop);
    const setRecoilUrlInfo = useSetRecoilState(urlState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, setDeviceInfo, deviceInfo, onClickTab } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // useState
    const [deviceItme, setDeviceItme] = useState([]);
    const [spgInfo, setSpgInfo] = useState([]);
    const [spgData, setSpgData] = useState(null);
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [layerPopUp, setLayerPopUp] = useState(false);
    const [layerPopMove, setLayerPopMove] = useState(false);
    const [chnanTree, setChnanTree] = useState(null);
    const [popreset, setPopreset] = useState(false);
    // 페이지
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.형명"), sfVal: "itemName" },
        { id: 2, sfDisp: t("라벨.시리얼번호"), sfVal: "serialNo" },
        { id: 3, sfDisp: t("라벨.판넬명"), sfVal: "panelName" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    // 기본 주소
    let appPath = `?zoneId=${recoilTree.zone.zoneId}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    if (recoilTree.subZone.subZoneId) {
        appPath = appPath + `&subZoneId=${recoilTree.subZone.subZoneId}`;
    }
    if (recoilTree.room.roomId) {
        appPath = appPath + `&roomId=${recoilTree.room.roomId}`;
    }
    // 페이징 적용된 주소
    if (sortData.sortField) {
        // 정렬 적용된 주소
        appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    }
    // spg 필터 적용된 주소
    if (spgData) {
        appPath = appPath + `&spgList=${spgData.spgName}`;
    }
    // 검색 필터 적용된 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            handleCurPage(0);
            const searchVal = {
                text: searchText,
                setSearch: setSearchTextField,
            };
            CUTIL.onClickSearch(searchVal);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
    }
    // 검색 초기화
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    useEffect(() => {
        // 등록
        handleOpenPop("pop-add-info", _jsx(DeviceAddPop, { popreset: popreset, setPopreset: setPopreset, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
        // 삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkArr: checkArr, setCheckArr: setCheckArr, setCheckItem: setCheckItem }));
    }, [popreset, searchText, checkArr]);
    function ClosePop(id) {
        setPopreset(true);
    }
    // 기기 등록 관리 목록  API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/item/manageList${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(recoilTree);
                setDeviceItme(data.body);
                setDeviceInfo(data.body[0]);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
                if (chnanTree && chnanTree !== recoilTree) {
                    setSortData({
                        sortField: "",
                        sort: "asc",
                    });
                    handleCurPage(0);
                    setCheckItem([]);
                    setCheckArr([]);
                    if (!isMobile) {
                        const selectId = document.getElementById("selects");
                        const selectId0 = document.getElementById("selects0");
                        selectId.click();
                        selectId0.click();
                        setSearchText("");
                        setSearchTextField({
                            searchField: searchFieldList[0].sfVal,
                            searchText: "",
                        });
                    }
                }
                else {
                    // data.body.map((err) => (err.msg));
                }
            }
        }
    }, [data, reload, chnanTree, isMobile, langIds]);
    // spg select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${recoilTree.company.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    function spgClick(item) {
        setSpgData(item);
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(deviceItme);
            var unique = checks.filter((item, pos) => checks.indexOf(item) === pos);
            const checksId = checkArr.concat(deviceItme.map((item) => item.itemIdPk));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let itemListId = deviceItme.map((item) => item.itemIdPk);
            setCheckItem(checkItem.filter((item) => !itemListId.includes(item.itemIdPk)));
            setCheckArr(checkArr.filter((item) => !itemListId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.itemIdPk]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el !== list));
            setCheckArr(checkArr.filter((el) => el !== list.itemIdPk));
        }
    }
    function DeviceInfo(e, list) {
        if (is1650M && (e.target.nodeName == "P" || e.target.nodeName == "TD")) {
            // e.preventDefault();
            var actTag = e.currentTarget;
            var activeLayer = actTag.getAttribute("data-pop");
            setPopInfo(activeLayer);
            CUTIL.jsopen_m_1650_Popup(e);
        }
        setDeviceInfo(list);
    }
    function LayerPopUp(e) {
        if (isMobile) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            if (!layerPopUp) {
                setLayerPopUp(true);
                setLayerPopMove(false);
            }
            else {
                setLayerPopUp(false);
            }
        }
    }
    function LayerPopMove(e) {
        if (!layerPopMove) {
            setLayerPopMove(true);
            setLayerPopUp(false);
        }
        else {
            setLayerPopMove(false);
        }
    }
    //상담 신청 이동
    function UrlMove(type) {
        setRecoilNoneUrlInfo(true);
        setRecoilUrlInfo(CONST.URL_INTRODUCTIONINQUIRY);
        navigate(CONST.URL_INTRODUCTIONINQUIRY);
        setConsultInfo({
            company: recoilTree.company,
            zone: recoilTree.zone,
            reUrl: "oper",
            type: type,
            itemInof: checkItem,
        });
    }
    function DevicePop(e) {
        CUTIL.jsopen_Popup(e);
        LayerPopUp(e);
    }
    function BatchMoev(type) {
        if (recoilTree.room.roomId) {
            onClickTab(type);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.분전소기준으로일괄등록이가능합니다") }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // 엑셀 리스트
    function ListExcell(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            // 기본 주소
            let appPath = `zoneId=${recoilTree.zone.zoneId}`;
            if (recoilTree.subZone.subZoneId) {
                appPath = appPath + `&subZoneId=${recoilTree.subZone.subZoneId}`;
            }
            if (recoilTree.room.roomId) {
                appPath = appPath + `&roomId=${recoilTree.room.roomId}`;
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/item/devices?${appPath}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    excelDownloadSaved(data.body);
                }
            }
        });
    }
    // List Download
    function excelDownloadSaved(excelData) {
        const excelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // 파일 타입 및 유니코드
        const excelFileExtension = ".xlsx"; // 확장자 명
        const excelFileName = `운영설비_${recoilTree.company.companyName}_${recoilTree.zone.zoneName}${recoilTree.subZone.subZoneId ? `_${recoilTree.subZone.subZoneName}` : ""}${recoilTree.room.roomId ? `_${recoilTree.room.roomName}` : ""}_${dayjs(new Date()).format("YYYY-MM-DD")}`; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([
            ["no", "spgName", "panelName", "itemName", "serialNo", "manufacturer", "	madeyyyyMM", "memo"],
            [
                "설명",
                "설비유형",
                `판넬명(GIS, 유입식TR 입력금지)`,
                `형명(배전반 입력금지)`,
                `시리얼번호(배전반 미 입력 가능)`,
                "제조사",
                "제조년월",
                "메모",
                "SPG 별 ElecInfo1",
                "SPG 별 ElecInfo2",
                "SPG 별 ElecInfo3",
                "SPG 별 ElecInfo4",
                "SPG 별 ElecInfo5",
                "SPG 별 ElecInfo6",
                "SPG 별 ElecInfo7",
                "SPG 별 ElecInfo8",
                "SPG 별 ElecInfo9",
                "SPG 별 ElecInfo10",
                "SPG 별 ElecInfo11",
                "SPG 별 ElecInfo12",
                "SPG 별 ElecInfo13",
                "SPG 별 ElecInfo14",
                "SPG 별 ElecInfo15",
                "SPG 별 ElecInfo16",
                "SPG 별 ElecInfo17",
                "SPG 별 ElecInfo18",
                "SPG 별 ElecInfo19",
                "SPG 별 ElecInfo20",
                "SPG 별 ElecInfo21",
                "SPG 별 ElecInfo2",
                "SPG 별 ElecInfo23",
                "SPG 별 ElecInfo24",
                "SPG 별 ElecInfo25",
                "SPG 별 ElecInfo26",
                "SPG 별 ElecInfo27",
                "SPG 별 ElecInfo28",
                "SPG 별 ElecInfo29",
                "SPG 별 ElecInfo30",
            ],
        ]);
        excelData.map((sheet, idx) => {
            XLSX.utils.sheet_add_aoa(excelSheet, [
                [
                    idx + 1,
                    sheet.spgName,
                    sheet.panelName,
                    sheet.itemName,
                    sheet.serialNo,
                    sheet.manufacturer,
                    sheet.madeyyyyMM ? dayjs(sheet.madeyyyyMM).format("YYYY-MM") : " ",
                    sheet.memo,
                    sheet.elecInfo.values[0],
                    sheet.elecInfo.values[1],
                    sheet.elecInfo.values[2],
                    sheet.elecInfo.values[3],
                    sheet.elecInfo.values[4],
                    sheet.elecInfo.values[5],
                    sheet.elecInfo.values[6],
                    sheet.elecInfo.values[7],
                    sheet.elecInfo.values[8],
                    sheet.elecInfo.values[9],
                    sheet.elecInfo.values[10],
                    sheet.elecInfo.values[11],
                    sheet.elecInfo.values[12],
                    sheet.elecInfo.values[13],
                    sheet.elecInfo.values[14],
                    sheet.elecInfo.values[15],
                    sheet.elecInfo.values[16],
                    sheet.elecInfo.values[17],
                    sheet.elecInfo.values[18],
                    sheet.elecInfo.values[19],
                    sheet.elecInfo.values[20],
                    sheet.elecInfo.values[21],
                    sheet.elecInfo.values[22],
                    sheet.elecInfo.values[23],
                    sheet.elecInfo.values[24],
                    sheet.elecInfo.values[25],
                    sheet.elecInfo.values[26],
                    sheet.elecInfo.values[27],
                    sheet.elecInfo.values[28],
                    sheet.elecInfo.values[29],
                    sheet.elecInfo.values[30],
                ],
            ], { origin: -1 });
            excelSheet["!cols"] = [
                //< --행 사이즈
                { width: 8 },
                { width: 10 },
                { width: 20 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 }, // 메모
            ];
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
    }
    // 유형 다른 곳 클릭 시 사라짐
    useEffect(() => {
        const handleClick = (e) => {
            //e.preventDefault();
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("etc") || targetElement.closest(".etc");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".popup-etc");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
                setLayerPopUp(false);
                setLayerPopMove(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: deviceItme && (_jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements == 0 ? "nodata" : ""}`, style: { paddingTop: isMobile ? "59px" : "24px" } }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("span", Object.assign({ className: "mr-24 font-14" }, { children: _jsx("strong", { children: t("라벨.설비유형") }) })), _jsxs("div", Object.assign({ className: "select comSpg w158", onClick: (e) => SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !spgData ? t("라벨.전체") : spgData.spgName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => spgClick(null) }, { children: t("라벨.전체") })), spgInfo.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => spgClick(item) }, { children: item.spgName }), "spgInfo_" + idx.toString())))] })] }))] })), _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: [_jsxs("div", Object.assign({ id: "selects", className: "select searchs", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: searchFieldList[0].sfDisp })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, className: "option", onClick: (e) => SelectClick(sf), "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-add etc ml-10", "data-pop": "pop-add-info" /* tooltip-link white// data-tooltip="점검일정 추가" */, onClick: (e) => LayerPopUp(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB4F1\uB85D\uC120\uD0DD\uD31D\uC5C5" })) })), _jsxs("ul", Object.assign({ className: `popup-etc ${layerPopUp ? "open" : ""}`, style: { display: layerPopUp ? "block" : "none" } }, { children: [_jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-g-s js-open", "data-pop": "pop-add-info", onClick: (e) => DevicePop(e) }, { children: _jsx("span", { children: t("라벨.단일등록") }) })) }), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-all", onClick: (e) => BatchMoev("BATCH") }, { children: _jsx("span", { children: t("라벨.일괄등록") }) })) })] })), _jsx("button", Object.assign({ type: "button", className: "btn btn-filedown  ml-8", onClick: (e) => ListExcell(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2E4\uC6B4\uB85C\uB4DC" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-bg  ml-8 js-open", "data-pop": "pop-delete", disabled: checkArr.length <= 0 ? true : false, onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-bg btn-ask etc ml-8", disabled: checkItem.length <= 0 ? true : false, onClick: (e) => LayerPopMove(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBB38\uC758" })) })), _jsxs("ul", Object.assign({ className: `popup-etc ${layerPopMove ? "open" : ""}`, style: { display: layerPopMove ? "block" : "none" } }, { children: [_jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-g-s", onClick: (e) => UrlMove("ASSESSMENT") }, { children: _jsx("span", { children: t("라벨.진단점검문의") }) })) }), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-all", onClick: (e) => UrlMove("CHANGE") }, { children: _jsx("span", { children: t("라벨.설비교체문의") }) })) })] }))] })) }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("운영관리.NODATA.운영설비") })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC120\uD0DD, \uC124\uBE44\uC720\uD615, \uBD84\uC804\uC18C, \uD615\uBA85, \uD310\uB12C\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638, \uC81C\uC870\uC0AC, \uC81C\uC870\uB144\uC6D4, \uBA54\uBAA8 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "4%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "19%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "17%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "12%" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w4p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkArr.length === 0
                                                        ? false
                                                        : deviceItme.length == deviceItme.filter((list) => checkArr.includes(list.itemIdPk)).length
                                                            ? true
                                                            : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "spgName" && sortData.sort === "desc" ? "desc" : "asc"}  m-none `, onClick: (e) => onClickSort("spgName") }, { children: _jsx("span", { children: t("라벨.설비유형") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "roomName" && sortData.sort === "desc" ? "desc" : "asc"}  sm-none `, onClick: (e) => onClickSort("roomName") }, { children: _jsx("span", { children: t("라벨.분전소") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "panelName" && sortData.sort === "desc" ? "desc" : "asc"}  sm-none `, onClick: (e) => onClickSort("panelName") }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "serialNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("serialNo") }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "manufacturer" && sortData.sort === "desc" ? "desc" : "asc"}  m-none `, onClick: (e) => onClickSort("manufacturer") }, { children: _jsx("span", { children: t("라벨.제조사") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "madeyyyyMM" && sortData.sort === "desc" ? "desc" : "asc"}  sm-none `, onClick: (e) => onClickSort("madeyyyyMM") }, { children: _jsx("span", { children: t("라벨.제조년월") }) }))] }) }), _jsx("tbody", { children: deviceItme.map((list, idx) => (_jsxs("tr", Object.assign({ className: `js-open-m-1650 ${deviceInfo.itemIdPk == list.itemIdPk ? "selected" : ""}`, "data-pop": "m-1650", onClick: (e) => DeviceInfo(e, list) }, { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", id: "t_1" + idx, checked: checkArr.includes(list.itemIdPk) ? true : false, onChange: (e) => CheckedList(e.target.checked, list), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "t_1" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.companySpg.spgName ? list.companySpg.spgName : "-" })) })), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.roomName ? list.roomName : "-" })) })), _jsx("td", Object.assign({ className: `${list.itemName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemName ? list.itemName : "-" })) })), _jsx("td", Object.assign({ className: `sm-none ${list.panel.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.panel.panelName.length }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.panel.panelName ? list.panel.panelName : "-" })) })), _jsx("td", Object.assign({ className: `${list.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.serialNo }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.serialNo ? list.serialNo : "-" })) })), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.manufacturer ? list.manufacturer : "-" })) })), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("p", { children: list.madeyyyyMM ? dayjs(list.madeyyyyMM).format("YYYY-MM") : "-" }) }))] }), "deviceList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "DEVICE", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] }))) }));
}
export default EquipmentRegist;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchFieldList, searchText, setSearchText, setSearchTextField } = props;
    const [searchBoolean, setSearchBoolean] = useState(false);
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        const searchVal = {
            id: "pop-search-small",
            text: searchText,
            setSearch: setSearchTextField,
        };
        CUTIL.onClickSearch(searchVal);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !searchBoolean ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList
                                        .filter((sf) => sf.sfVal !== "panelName")
                                        .map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), `sf_${idx.toString()}`))) })] })), _jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function DeviceAddPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    //props
    const { popreset, setPopreset } = props;
    // useState
    const [spgInfo, setSpgInfo] = useState([]);
    const [spg, setSpg] = useState(null);
    const [elecInfo, setEleInfo] = useState([]);
    const [itemName, setItemName] = useState("");
    const [panelName, setPanelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [memo, setMemo] = useState("");
    const [today, setToday] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [file, setFile] = useState([]);
    const lastNum = 10;
    //
    const [subZoneInfo, setSubZoneInfo] = useState([]);
    const [subZone, setSubZone] = useState(null);
    const [roomInfo, setRoomInfo] = useState([]);
    const [room, setRoom] = useState(null);
    // spg select
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/${recoilTree.company.companyId}/spgs`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: recoilTree.zone.zoneId + reload + langIds.toString() + popreset,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgInfo(data.body);
                if (recoilTree.subZone.subZoneId) {
                    setSubZone(recoilTree.subZone);
                }
                else {
                    setSubZone(null);
                }
                if (recoilTree.room.roomId) {
                    setRoom(recoilTree.room);
                }
                else {
                    setRoom(null);
                }
                if (popreset) {
                    PopClose("pop-add-info");
                    setPopreset(false);
                }
            }
            else {
                // need error handle
            }
        }
    }, [data, popreset, recoilTree.zone.zoneId, langIds]);
    // spg select 후 전력 정보 추출
    function onClickSpg(val) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${val.companySpgId}/elecinfos/type`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setEleInfo(data.body.map((item, idx) => (Object.assign(Object.assign({}, item), { value: item.type < 2 ? "" : langIds < 2 ? item.unit[0] : item.unitEn[0], idx: idx, 
                        // uiType: item.type,
                        unit: item.type < 2
                            ? item.unit
                            : item.unit.map((value, index) => ({
                                name: value,
                                selected: false,
                                id: idx,
                                unitId: value[0] + index,
                            })), unitEn: item.type < 2
                            ? item.unitEn
                            : item.unitEn.map((value, index) => ({
                                name: value,
                                selected: false,
                                id: idx,
                                unitEnId: value[0] + index,
                            })), checked: false }))));
                    setSpg(val);
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    // elecInfo type2
    function onClickElecInfo(item, list, id, unitId, blooean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${spg.companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.name,
                    elecCode: item.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let itemArr = elecInfo.map((smenu) => smenu.code === item.code
                        ? Object.assign(Object.assign({}, smenu), { checked: true, value: list.name, unit: smenu.type < 2
                                ? smenu.unit
                                : smenu.unit.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item), unitEn: smenu.type < 2
                                ? smenu.unitEn
                                : smenu.unitEn.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item) }) : smenu);
                    const selcetItem = data.body.map((item) => (Object.assign(Object.assign({}, item), { value: "", 
                        // uiType: 3,
                        id: id })));
                    const listArr = itemArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                    const elecInfoListArr = (data) => {
                        const uniqueItems = new Set();
                        return data.filter((item) => {
                            const itemString = JSON.stringify(item);
                            if (uniqueItems.has(itemString)) {
                                return false;
                            }
                            else {
                                uniqueItems.add(itemString);
                                return true;
                            }
                        });
                    };
                    // 중복 제거된 데이터
                    const uniqueData = elecInfoListArr(listArr);
                    if (blooean) {
                        const dataArr = uniqueData.filter((item) => item.id !== id);
                        const changeData = dataArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                        setEleInfo(changeData);
                    }
                    else {
                        setEleInfo(uniqueData);
                    }
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.IdScrollIntoView(id, "form__input");
        setSubZone(null);
        setRoom(null);
        setSpg(null);
        setItemName("");
        setPanelName("");
        setSerialNo("");
        setManufacturer("");
        setMemo("");
        setToday("");
        setEleInfo([]);
        setFile([]);
        setErrorList([]);
        CUTIL.jsclose_Popup(id);
    }
    // 전력정보 등록
    function ElecIfoChange(e, id) {
        setEleInfo(elecInfo.map((smenu) => (smenu.companyElecId === id ? Object.assign(Object.assign({}, smenu), { value: e.target.value }) : smenu)));
    }
    function onChangeItem(e) {
        setErrorList(errorList.filter((err) => err.field !== "itemName"));
        setItemName(e.target.value);
    }
    function onChangePanel(e) {
        setErrorList(errorList.filter((err) => err.field !== "panelName"));
        setPanelName(e.target.value);
    }
    function onChangeSerialNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "serialNo"));
        setSerialNo(e.target.value);
    }
    function onChangeManufacturer(e) {
        setErrorList(errorList.filter((err) => err.field !== "manufacturer"));
        setManufacturer(e.target.value);
    }
    function onChangeTodayMonth(e) {
        setErrorList(errorList.filter((err) => err.field !== "madeyyyyMM"));
        if (e.target.value.length <= 7) {
            setToday(e.target.value);
        }
    }
    function itemAddClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!subZone || !room) {
                setErrorList([
                    !subZone && { field: "subZoneId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !room && { field: "roomId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
            }
            else {
                setRecoilIsLoadingBox(true);
                let data = null;
                let itemArr = [];
                for (let i = 0; i < elecInfo.length; i++) {
                    itemArr.push({
                        elecCode: elecInfo[i].code,
                        value: elecInfo[i].value,
                    });
                }
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/product/item`,
                    appQuery: {
                        roomId: room.roomId,
                        spgName: spg ? spg.spgName : "",
                        itemName: itemName,
                        panelName: panelName,
                        serialNo: serialNo,
                        manufacturer: manufacturer,
                        madeyyyyMM: dayjs(today).format("YYYYMM").toString(),
                        elecInfo: itemArr,
                        memo: memo,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        if (file.length > 0) {
                            uploadFileImage(data.body.itemIdPk);
                        }
                        else {
                            setReload(true);
                            PopClose("pop-add-info");
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가등록되었습니다") }));
                            CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                            setReload(false);
                            setRecoilIsLoadingBox(false);
                        }
                    }
                    else {
                        // need error handle
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 첨부파일 업로드
    function uploadFileImage(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?itemId=${itemId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/item${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFile([]);
                    setReload(true);
                    PopClose("pop-add-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    if (data.errorList) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: "오류로 인하여 첨부파일이 제거되어 기기가 등록되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    //
    // SubZone
    function SubZoneSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubZoneInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickSubZone(item) {
        setErrorList(errorList.filter((err) => err.field !== "subZoneId"));
        setSubZone(item);
    }
    // room
    function RoomSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/subzone/${subZone.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRoomInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickRoom(info) {
        setErrorList(errorList.filter((err) => err.field !== "roomId"));
        setRoom(info);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneId ? recoilTree.subZone.subZoneName : t("라벨.전체") }), _jsx("li", { children: recoilTree.room.roomId ? recoilTree.room.roomName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.설비정보") }), !popreset && (_jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30 devicePop" }, { children: [!recoilTree.subZone.subZoneId && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세사업장명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select subzone ${errorList.filter((err) => err.field === "subZoneId").length > 0 ? " input-error" : ""}`, onClick: (e) => SubZoneSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: subZone ? subZone.subZoneName : t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: subZoneInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSubZone(info) }, { children: info.subZoneName }), "subZoneDevice_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "subZoneId").map((err) => err.msg) }))] }))] })), recoilTree.room.roomId ? (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp26", value: room ? room.roomName : "", readOnly: true }) }))] })) : (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select room ${errorList.filter((err) => err.field === "roomId").length > 0 ? " input-error" : ""}`, onClick: (e) => subZone.subZoneId && RoomSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: room && room.roomId ? room.roomName : t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: roomInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom(info) }, { children: info.roomName }), "room_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "roomId").map((err) => err.msg) }))] }))] })), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg ${errorList.filter((err) => err.field === "spgName").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !spg ? t("라벨.클릭선택") : spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), "spgInfos_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.형명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "itemName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp22", placeholder: spg && spg.spgName == "배전반" ? "" : t("라벨.텍스트입력"), value: itemName, onChange: (e) => onChangeItem(e), disabled: spg && spg.spgName == "배전반" ? true : false }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "itemName").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : "star"}` }, { children: t("라벨.판넬명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "panelName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp23", placeholder: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : t("라벨.텍스트입력"), value: panelName, onChange: (e) => onChangePanel(e), disabled: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "panelName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.시리얼번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "serialNo").length > 0 ? " input-error" : ""}`, type: "text", id: "inp24", placeholder: t("라벨.텍스트입력"), value: serialNo, onChange: (e) => onChangeSerialNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "serialNo").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "manufacturer").length > 0 ? " input-error" : ""}`, type: "text", id: "inp25", placeholder: t("라벨.텍스트입력"), value: manufacturer, onChange: (e) => onChangeManufacturer(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "manufacturer").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제조년월") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "madeyyyyMM").length > 0 ? " input-error" : ""}`, type: "text", id: "inp28", placeholder: t("라벨.제조년월입력"), value: today.toString().replace(/(\d{4})(\d{1})/, "$1-$2"), onChange: (e) => onChangeTodayMonth(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "madeyyyyMM").map((err) => err.msg) }))] }))] }), elecInfo.map((item, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: `tit mt-0` }, { children: [langIds > 1 ? item.elecInfoNameEnglish : item.elecInfoName, " ", item.type < 2 && `(${item.unit})`, _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", item.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: item.type < 2 ? (_jsx("input", { type: "text", id: "inp_" + idx, value: item.value, onChange: (e) => ElecIfoChange(e, item.companyElecId) })) : (
                                                // {(errorList.filter(err => (err.field === "companyId")).length > 0) ? " input-error" : ""}
                                                _jsxs("div", Object.assign({ className: `select elecinfo_${idx} `, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: langIds > 1
                                                                ? item.unitEn.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unitEn_" + index.toString())))
                                                                : item.unit.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unit_" + index.toString()))) })] }))) }))] }, "lsinfoEdit_" + idx.toString()))), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", { children: t("라벨.첨부파일") }) })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] })))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => PopClose("pop-add-info") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => itemAddClick(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { checkArr, setCheckArr, setCheckItem } = props;
    function DeviceDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            let success = [];
            let fail = [];
            setRecoilIsLoadingBox(true);
            for (let i = 0; i < checkArr.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/product/item/${checkArr[i]}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                if (success.length > 0) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setCheckArr([]);
                    setCheckItem([]);
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList.field((err) => err.field == "itemId").length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "필수 인자가 포함되지 않은 경우나 호출 인자값의 데이타 타입이 적절하지 않거나 허용된 범위를 벗어난 경우" }));
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "삭제를 실패했습니다" }));
                    }
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.기기를삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            DeviceDelete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
